import { Component } from '@theme/component';

class SubscriptionWidget extends Component {
  requiredRefs = ['purchaseType', 'sellingPlanInput'];

  connectedCallback() {
    super.connectedCallback();
    this.#addEventListeners();
  }

  #addEventListeners() {
    this.refs.purchaseType?.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (radio.value === 'subscription') {
          this.refs.sellingPlanInput.setAttribute('name', 'selling_plan');
        } else {
          this.refs.sellingPlanInput.removeAttribute('name');
        }
      })
    })
  }
}

if (!customElements.get('subscription-widget')) {
  customElements.define('subscription-widget', SubscriptionWidget);
}
